export enum ItemId {
  FastInserter = 'fast-inserter',
  Inserter = 'inserter',
  LongHandedInserter = 'long-handed-inserter',
  MineControlTower = 'mine-control-tower',
  MiningMachine = 'mining-machine',
  Module = 'module',
  Pipe = 'pipe',
  Pumpjack = 'pumpjack',
  Somersloop = 'somersloop',
  StackInserter = 'stack-inserter',
}
